import React, { useState } from "react";

import { useDispatch } from "react-redux";

// redux imports
import { resetStore } from "../../../redux/actions/categoriesActions";

// Components imports
import CategoryItem from "../CategoriesItem";
import Button from "../../common/Button";

// Icons imports
import { AiOutlinePlus } from "react-icons/ai";
import { BiEditAlt } from "react-icons/bi";
import { FaRegSave } from "react-icons/fa";

// Scss imports
import css from "./CategoriesContainer.module.scss";
interface CategoriesContainerProps {
  editCategory: any;
  createCategory: any;
  setRenderedNewCategoryItem: any;
  renderedNewCategoryItem: any;
  baseNumber: any;
  name: string;
  shelfLife: any;
  handleChange: any;
  categories: any;
  addCategoryStatus: any;
  showAllCategories?: boolean;
  setUserInput?: any;
}

const CategoriesContainer: React.FC<CategoriesContainerProps> = ({
  editCategory,
  createCategory,
  setRenderedNewCategoryItem,
  renderedNewCategoryItem,
  baseNumber,
  name,
  shelfLife,
  handleChange,
  categories,
  addCategoryStatus,
  showAllCategories,
  setUserInput
}) => {
  // State to store number of children
  const [numberOfChildren, setNumberOfChildren] = useState(0);

  const dispatch = useDispatch();

  // Array with children
  const children: any = [];

  // Function for adding new category on + button click
  const addNewCategory = () => {
    setNumberOfChildren(numberOfChildren + 1);
    setRenderedNewCategoryItem(true);
    dispatch(resetStore());
  };

  const handleChangeNewi = (e: any) => {
  };

  // With for loop push new item in array
  for (let i = 0; i < numberOfChildren; i++) {
    children.push(
      <CategoryItem
        icon={<FaRegSave color="#982d8f" fontSize="2.3rem" />}
        number={categories ? categories.length + 1 : 1}
        deleteIcon={false}
        sendData={createCategory}
        handleChange={handleChange}
        baseNumber={baseNumber}
        name={name}
        shelfLife={shelfLife}
        newItem={true}
        showAllCategories={showAllCategories}
      />
    );
  }

  // Delete category item
  /*const deleteCategoryFunction = (id) => {
    dispatch(deleteCategory(id));
	};*/

  return (
    <div className={css.container}>
      {categories
        ? categories.map((category, index) => {
            return (
              <CategoryItem
                key={category.id}
                number={index + 1}
                id={category.id}
                icon={<BiEditAlt color="#982d8f" fontSize="2.3rem" />}
                deleteIcon={true}
                sendData={editCategory}
                handleChange={handleChangeNewi}
                category={category}
                newItem={false}
                showAllCategories={showAllCategories}
                setUserInput={setUserInput}
              />
            );
          })
        : ""}

      <div id="addItem" className={css.addItem}>
        {children}
      </div>
      {/* Add new item button */}
      {!showAllCategories && (
        <div className={css.buttonHolder}>
          <Button
            icon={<AiOutlinePlus color="#982d8f" fontSize="2.3rem" />}
            onButtonClickHandler={addNewCategory}
            style={{ borderRadius: "5rem", marginLeft: "2rem" }}
            //refButton={refPrevButton}
            disabledButton={renderedNewCategoryItem}
            //hidden={hiddenPrev}
          />
        </div>
      )}
    </div>
  );
};

export default CategoriesContainer;
